/*
 * End of Summer Sale countdown (25 t/m 30 september 2026).
 *
 * Alle drie de plekken (hero, announcement bar, PDP) renderen hetzelfde
 * <sale-countdown> element met dezelfde data-attributen, dus ze lopen per
 * definitie synchroon: het doelmoment wordt uit dezelfde absolute epoch-
 * waarden berekend, niet uit de klok van de bezoeker.
 *
 * Dagelijkse reset: het venster loopt van data-start tot data-end. Met
 * data-daily-reset telt de timer af naar de eerstvolgende grens op
 * start + n * data-cycle (24 uur), en begint daarna opnieuw. De laatste
 * cyclus wordt afgekapt op data-end; daarna verdwijnt het element.
 *
 * Tijdzone: start en end komen als epoch-milliseconden uit Liquid, berekend
 * uit een ISO-string met expliciete offset (+02:00). Elke bezoeker ziet
 * dus dezelfde stand, ongeacht waar hij zit.
 *
 * Na de actie: zet "Actie-countdown tonen" uit in de theme settings. Deze
 * asset en de bijbehorende blokken kunnen daarna in een keer weg.
 */
(function () {
  var FALLBACK_LABELS = { day: 'dag', days: 'dagen', hour: 'uur', hours: 'uren', minute: 'min', minutes: 'min', second: 'sec', seconds: 'sec', d: 'd', h: 'u', m: 'm', s: 's' };

  function labels() {
    var t = (window.theme && window.theme.dateStrings) || {};
    var out = {};
    for (var key in FALLBACK_LABELS) {
      out[key] = t[key] || FALLBACK_LABELS[key];
    }
    return out;
  }

  function pad(value) {
    return value < 10 ? '0' + value : String(value);
  }

  /*
   * QA-hulpje: met ?sale_countdown_preview in de URL schuift het hele venster
   * naar nu toe, zodat de timer te beoordelen is voordat de actie begint. De
   * duur en de dagelijkse cyclus blijven gelijk. Eenmaal per pagina berekend,
   * zodat alle timers dezelfde verschuiving krijgen en dus synchroon blijven.
   * Zonder die parameter is de verschuiving 0 en verandert er niets.
   */
  var previewShiftMs = null;
  function previewShift(start) {
    if (previewShiftMs !== null) return previewShiftMs;

    previewShiftMs = 0;
    try {
      if (new URLSearchParams(window.location.search).has('sale_countdown_preview')) {
        var now = Date.now();
        if (now < start) previewShiftMs = start - now;
      }
    } catch (e) {
      previewShiftMs = 0;
    }
    return previewShiftMs;
  }

  /*
   * Een gedeelde ticker voor alle timers op de pagina. Met een eigen interval
   * per element lopen de tikmomenten enkele tientallen milliseconden uiteen en
   * kunnen twee timers kort een verschillende seconde tonen. Nu rendert elke
   * timer in dezelfde tik, dus ze zijn ook op het scherm altijd gelijk.
   */
  var instances = new Set();
  var ticker = null;

  function startTicker() {
    if (ticker) return;
    ticker = setInterval(function () {
      instances.forEach(function (el) { el.tick(); });
    }, 1000);
  }

  function stopTickerIfIdle() {
    if (ticker && instances.size === 0) {
      clearInterval(ticker);
      ticker = null;
    }
  }

  class SaleCountdown extends HTMLElement {
    connectedCallback() {
      if (!this.initialized) {
        this.initialized = true;

        this.start = parseInt(this.getAttribute('data-start'), 10);
        this.end = parseInt(this.getAttribute('data-end'), 10);
        this.cycle = parseInt(this.getAttribute('data-cycle'), 10) || 86400000;
        this.dailyReset = this.getAttribute('data-daily-reset') === 'true';
        this.compact = this.getAttribute('data-compact') === 'true';
        this.unitsEl = this.querySelector('[data-sale-countdown-units]');

        if (!this.unitsEl || isNaN(this.start) || isNaN(this.end) || this.cycle <= 0) {
          this.remove();
          return;
        }

        var shift = previewShift(this.start);
        this.start -= shift;
        this.end -= shift;
      }

      /*
       * Ook bij een herverbinding doorstarten. De announcement bar zit in een
       * Flickity-carousel die de slide verplaatst; dat geeft een disconnect en
       * daarna een connect. Zonder deze doorstart bleef de timer in de bar op
       * zijn eerste stand staan terwijl de hero en de PDP gewoon doortelden.
       */
      this.run();
    }

    run() {
      if (!this.unitsEl || instances.has(this)) return;
      instances.add(this);
      this.tick();
      startTicker();
    }

    disconnectedCallback() {
      instances.delete(this);
      stopTickerIfIdle();
    }

    /* Het moment waar nu naartoe geteld wordt. Buiten het venster: null. */
    target(now) {
      if (now < this.start || now >= this.end) return null;
      if (!this.dailyReset) return this.end;

      var elapsed = now - this.start;
      var next = this.start + (Math.floor(elapsed / this.cycle) + 1) * this.cycle;
      return Math.min(next, this.end);
    }

    tick() {
      var now = Date.now();
      var target = this.target(now);

      if (target === null) {
        this.stop();
        return;
      }

      this.render(target - now);
      this.hidden = false;
    }

    render(remaining) {
      var total = Math.max(remaining, 0);
      var days = Math.floor(total / 86400000);
      var hours = Math.floor((total % 86400000) / 3600000);
      var mins = Math.floor((total % 3600000) / 60000);
      var secs = Math.floor((total % 60000) / 1000);
      var l = labels();
      var html = '';

      if (this.compact) {
        if (days > 0) html += '<span class="sale-countdown__unit">' + days + l.d + '</span>';
        html +=
          '<span class="sale-countdown__unit">' + pad(hours) + l.h + '</span>' +
          '<span class="sale-countdown__unit">' + pad(mins) + l.m + '</span>' +
          '<span class="sale-countdown__unit">' + pad(secs) + l.s + '</span>';
      } else {
        if (days > 0) {
          html += this.unit(days, days === 1 ? l.day : l.days);
        }
        html +=
          this.unit(pad(hours), hours === 1 ? l.hour : l.hours) +
          this.unit(pad(mins), l.minutes) +
          this.unit(pad(secs), l.seconds);
      }

      this.unitsEl.innerHTML = html;
    }

    unit(value, label) {
      return (
        '<span class="sale-countdown__unit">' +
        '<span class="sale-countdown__value">' + value + '</span>' +
        '<span class="sale-countdown__label">' + label + '</span>' +
        '</span>'
      );
    }

    stop() {
      instances.delete(this);
      this.hidden = true;
      stopTickerIfIdle();
    }
  }

  if (!customElements.get('sale-countdown')) {
    customElements.define('sale-countdown', SaleCountdown);
  }
})();
